import { defaultRegion } from "common/config";
import { atom } from "jotai";

export const filtersOpenAtom = atom<boolean>(false);
export const mapVisibleOnMobileAtom = atom<boolean>(true);
export const leftPanelExpandedAtom = atom<boolean>(true);

export const mobileListViewAtom = atom<boolean>(true);

// Tracks where the mobile venue detail was opened from (list or map), so the
// back action can return the user to the same view. Shared by the search page
// and the What's Nearby map.
export const mapDetailOriginAtom = atom<"list" | "map">("list");

export const venueDetailsOpenedAtom = atom<boolean>(false);
export const searchVenueAtom = atom<string>("");
export const searchTermInputAtom = atom<string>("");
export const mapCenterAtom = atom({
  lat: defaultRegion.latitude,
  lng: defaultRegion.longitude,
});
export const savedPlaceIdToViewAtom = atom<string>("");
export const savedPlaceByUserIdToViewAtom = atom<string>("");
export const savedPlaceSortByToViewAtom = atom<string>("");
export const savedPlaceIdToViewDataChangedAtom = atom<boolean>(false);
export const hoveredVenueIdAtom = atom<string>("");
export const viewModeAtom = atom<"mapper" | "user">("mapper");
export const searchOverlayOpenAtom = atom<boolean>(false);
export const activeSavedSearchIdAtom = atom(null as string | number | null);

// Stores a Google place_id selected on the home page (where there is no map).
// BasicMapView reads this on mount and dispatches selectGooglePlace to resolve it.
// Empty string means "nothing pending".
export const pendingGooglePlaceIdAtom = atom<string>("");

// Stores a Google place_id for an area/neighbourhood selected on the home page.
// BasicMapView reads this on mount, geocodes it, pans the map, and runs a nearby search.
// Empty string means "nothing pending".
export const pendingGoogleAreaIdAtom = atom<string>("");

// Stores a JSON-serialised compound search selected on the home page.
// Shape: { locationQuery: string, searchTerm: string, matchedBusinessType: string | null }
// BasicMapView reads this on mount, geocodes locationQuery, pans, and runs the search.
// Empty string means "nothing pending".
export const pendingCompoundSearchAtom = atom<string>("");
